// Vendors
import React, { useState } from 'react';
import axios from 'axios';

const Messages = ({
  projectID,
  openAccordion,
  handleToggleAccordion,
  _isSubscribed,
  messages,
  setMessages
}) => {
  const [newMessage, setNewMessage] = useState('');

  const handlePostMessage = () => {
    if (!newMessage || !projectID) return;

    _isSubscribed = true;

    const formData = new FormData();
    formData.append('action', 'wl_pip_post_project_message');
    formData.append('message', newMessage);
    formData.append('pid', projectID);

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(
        ({
          data: {
            success,
            data: { comments }
          }
        }) => {
          if (_isSubscribed) {
            if (success) {
              setMessages(comments);
              setNewMessage('');
            }
          }
        }
      )
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="grid__col-xs-12 u--margin-bottom-20">
      <button
        className={`btn btn--white btn--block btn--lg btn--pip-accordion btn--has-arrow module-hover-root ${
          openAccordion['project-messages'] === true
            ? 'btn--pip-accordion--on'
            : ''
        }`}
        type="button"
        onClick={() => handleToggleAccordion('project-messages')}
      >
        <span className="btn__content u--display-flex u--align-items-center u--justify-content-space-between u--padding-left-20 u--padding-right-20 u--padding-top-5 u--padding-bottom-5 u--height-auto">
          <span className="btn__text">Project Messages</span>
          <span className="btn__arrow"></span>
        </span>
      </button>
      <div
        className={
          openAccordion['project-messages'] === true
            ? 'u--display-block u--padding-top-20 u--squash-end u--padding-bottom-10'
            : 'u--display-none'
        }
      >
        <div
          className="form__field u--margin-bottom-20"
          style={{ maxWidth: '600px' }}
        >
          <textarea
            type="textarea"
            className="form__textarea form__textarea--no-shadow"
            value={newMessage}
            onChange={(event) => setNewMessage(event.target.value)}
          />
        </div>
        <button
          className="btn btn--gold"
          type="button"
          disabled={!newMessage}
          onClick={() => handlePostMessage()}
        >
          <span className="btn__content">
            <span className="btn__text">Post New Message</span>
          </span>
        </button>

        {messages.length === 0 && (
          <>
            <hr />
            <p>There are currently no messages for this Project.</p>
          </>
        )}

        {messages.length > 0 && (
          <>
            <hr />
            {messages.map(
              ({
                comment_is_new,
                comment_by_builder,
                comment_date,
                comment_author,
                comment_content,
                comment_ID
              }) => (
                <div
                  key={comment_ID}
                  className={`message${
                    comment_is_new == 1 ? ' message--is-new' : ''
                  }${comment_by_builder == 1 ? ' message--mine' : ''}`}
                >
                  <div className="message__meta">
                    <h5 className="message__date">
                      {comment_is_new == 1 ? (
                        <span className="message__date--new">NEW — </span>
                      ) : (
                        ''
                      )}
                      {comment_date}
                    </h5>
                    <h5 className="message__author">
                      {comment_by_builder == 1 ? comment_author : 'PERC Admin'}
                    </h5>
                  </div>
                  <p
                    className="message__content"
                    dangerouslySetInnerHTML={{ __html: comment_content }}
                  />
                </div>
              )
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Messages;
